<template>
   <div style="width: 100%; height: 100%;">
      <div class="custom-container">
         <v-card flat>
            <v-card-title class="headline">
               Mitarbeitergespräche analysieren
            </v-card-title>
         </v-card>
         <v-card class="mt-4" flat>
            <v-card-title>
               Mitarbeiter
            </v-card-title>
            <v-card-text>
               Insgesamt: {{ employeesData.total }} <br>
               Davon hatten Gespräche dieses Jahr: {{ employeesData.interviewed_count }} <br>
               Davon hatten keine Gespräche dieses Jahr: {{ employeesData.not_interviewed_count }}
            </v-card-text>
         </v-card>
         <v-card>
            <v-tabs>
               <v-tab class="primary--text">Offen</v-tab>
               <v-tab class="primary--text">Durchgeführt</v-tab>

               <!--Not interviewed-->
               <v-tab-item eager>
                  <v-card-title>
                     <v-row>
                        <v-col cols="12" sm="9" md="9">
                           <v-text-field
                              v-model="searchEmployees"
                              append-icon="mdi-magnify"
                              label="Suchen"
                              single-line
                              hide-details
                           ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                           <v-select
                              label="Jahr"
                              v-model="year"
                              :items="years"/>
                        </v-col>
                     </v-row>

                  </v-card-title>
                  <EmployeeInterviewsUtilityEmployeesDataTable :headers="headersEmployees" :search="searchEmployees" :loading="loading"
                                                               :items="employeesData.not_interviewed"
                                                               type="hr-department">
                     <!--Customizing default rows-->
                  </EmployeeInterviewsUtilityEmployeesDataTable>
               </v-tab-item>


               <!--Interviewed-->
               <v-tab-item eager>
                  <v-card-title>
                     <v-row>
                        <v-col cols="12" sm="9" md="9">
                           <v-text-field
                              v-model="searchEmployees"
                              append-icon="mdi-magnify"
                              label="Suchen"
                              single-line
                              hide-details
                           ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                           <v-select
                              label="Jahr"
                              v-model="year"
                              :items="years"/>
                        </v-col>
                     </v-row>
                  </v-card-title>
                  <EmployeeInterviewsUtilityEmployeesDataTable :headers="headersEmployees" :search="searchEmployees"
                                                               :loading="loading"
                                                               :items="employeesData.interviewed" type="hr-department">
                     <!--Customizing default rows-->
                  </EmployeeInterviewsUtilityEmployeesDataTable>
               </v-tab-item>
            </v-tabs>
         </v-card>
         <v-card class="mt-4" flat>
            <v-card-title>
               Risikobewertung
            </v-card-title>
            <v-card-text>
               Durchschnitt über alle Jahre: {{ riskScore.total }} <br>
               Durchschnitt dieses Jahr: {{ riskScore.this_year }}
            </v-card-text>
         </v-card>
         <v-card class="mt-4" flat>
            <v-card-title>
               Weiterentwicklung
            </v-card-title>

         </v-card>
         <v-card>
            <v-card-title>
               <v-text-field
                  v-model="searchAdvancements"
                  append-icon="mdi-magnify"
                  label="Suchen"
                  single-line
                  hide-details
               ></v-text-field>
            </v-card-title>
            <EmployeeInterviewsUtilityAdvancementsDataTable :headers="headersAdvancements" :search="searchAdvancements"
                                                            :items="advancements">
               <!--Customizing default rows-->
            </EmployeeInterviewsUtilityAdvancementsDataTable>
         </v-card>
      </div>
   </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
   props: [],
   name: "",
   data: () => ({
      loading: false,
      year: null,
      employeesData: {
         total: '',
         interviewed_count: '',
         not_interviewed_count: '',
         interviewed: [],
         not_interviewed: [],
      },
      riskScore: {
         total: '',
         this_year: '',
      },
      searchEmployees: '',
      searchAdvancements: '',
      headersEmployees: [
         {text: 'Personalnummer', value: 'staff_number'},
         {text: 'Name', value: 'full_name'},
         {text: 'E-Mail-Adresse', value: 'email'},
         {text: 'Führungskraft', value: 'supervisors_names'},
         {text: 'Organisationseinheit', value: 'orga_unit'},
         {value: 'action', align: 'end'},
      ],
      advancements: [],
      headersAdvancements: [
         {text: 'Personalnummer', value: 'interviewed_staff_number'},
         {text: 'Vorname', value: 'interviewed_first_name'},
         {text: 'Nachname', value: 'interviewed_last_name'},
         {text: 'Organisationseinheit', value: 'orga_unit'},
         /*{ text: 'Pläne', value: 'plans'},*/
         {text: 'Typ', value: 'actions_type'},
         {text: 'Verantwortlicher', value: 'actions_responsible'},
         /*{ text: 'Anmerkung', value: 'note'},*/
         {value: 'action'},
      ]

   }),
   created() {
      this.getEmployees();
      this.getRiskScore();
      this.getAdvancements();
   },
   watch: {
     year: function () {
        this.getEmployees();
     }
   },
   computed: {
      years: function () {
         let startYear = 2020;
         const endYear = new Date().getFullYear();
         let years = [];

         for (let i = startYear; i <= endYear; i++) {
            years.push({text: startYear, value: startYear});
            startYear++;
         }

         return years;
      }

   },
   methods: {
      ...mapActions({}),
      getEmployees() {
         this.loading = true;
         let url = this.year ? '/analysis/employees?year=' + this.year : '/analysis/employees';
         this.axios.get(url).then((response) => {
            this.employeesData.total = response.data.total;
            this.employeesData.interviewed_count = response.data.interviewed_count;
            this.employeesData.interviewed = response.data.interviewed;
            this.employeesData.not_interviewed_count = response.data.not_interviewed_count;
            this.employeesData.not_interviewed = response.data.not_interviewed;
            this.loading = false;
         });
      },
      getRiskScore() {
         this.axios.get('/analysis/risk-score').then((response) => {
            this.riskScore.total = response.data.total;
            this.riskScore.this_year = response.data.this_year;
         });
      },
      getAdvancements() {
         this.axios.get('/analysis/advancements').then((response) => {
            this.advancements = response.data.advancements;
         });
      }

   },
}
</script>

<style scoped>

</style>
